export default {
  Layout: () => import('@/views/layout'),
  Home: () => import('@/views/home'),

  // 系统管理
  User: () => import('@/views/system/user'),
  Role: () => import('@/views/system/role'),
  Notice: () => import('@/views/system/notice'),
  Menu: () => import('@/views/system/menu'),
  Dict: () => import('@/views/system/dict'),
  Dept: () => import('@/views/system/dept'),

  Index: () => import('@/views/business/index'),

  About: () => import('@/views/business/about'),
  Tech: () => import('@/views/business/tech'),
  Car: () => import('@/views/business/car'),
  Advantage: () => import('@/views/business/advantage'),
  Case: () => import('@/views/business/case'),
  Development: () => import('@/views/business/development'),
  SocialValue: () => import('@/views/business/socialValue'),
  Common: () => import('@/views/business/common'),
}
